import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, SettingsIcon } from 'lucide-react';
import { AvisAtna } from '../components/avis/AvisAtna';
import { ImportantForYou } from '../components/avis/ImportantForYou';
import { NoticeFeed, type NoticeFilter } from '../components/avis/NoticeFeed';
export function AvisNotifications() {
  const [filter, setFilter] = useState<NoticeFilter>('All');
  const handleChip = (chip: string) => {
    if (chip === 'My important alerts') setFilter('Important');
    if (chip === 'Unread') setFilter('Unread');
    if (chip === 'This week') setFilter('All');
  };
  return <main className="bg-white" data-id="element-1889" data-mp="382ah70i0c3sk">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1890" data-mp="380zc8xctspzv">
        <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-1891" data-mp="3c2kocghjd090">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1892" data-mp="3naq5jgrof6i">
            Home
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1893" data-mp="1o6z4dls4sq03" />
          <span aria-current="page" data-id="element-1894" data-mp="1o78vxdstr57w">Notifications</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-1895" data-mp="1j8xmh46fywq7">
          <div data-id="element-1896" data-mp="1xxamcc8ngzpz">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-1897" data-mp="1xxu33pmkdi2f">
              Notifications
            </h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-1898" data-mp="1t3zce28jk2tu">Stay on top of what concerns you.</p>
          </div>
          <Link to="/notifications/settings" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1899" data-mp="26zbhn3kbpbp0">
            <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-1900" data-mp="mhvo754pg1ta" />
            Settings
          </Link>
        </header>

        <div className="mt-8" data-id="element-1901" data-mp="hkvfemgh0kyh">
          <AvisAtna onFilter={handleChip} data-id="element-1902" data-mp="2hljxytce1kns" />
        </div>

        <ImportantForYou data-id="element-1903" data-mp="2hn4tal6j17mp" />
        <NoticeFeed filter={filter} onFilterChange={setFilter} data-id="element-1904" data-mp="2mjljrm177y2y" />
      </div>
    </main>;
}